// SPDX-License-Identifier: GPL-3.0-or-later
// Seeded random number generator for the engine (mulberry32).
// The engine never calls Math.random. Every random value comes from one Rng.
// The same seed gives the same list of values.

export class Rng {
  private state: number;

  /** @param seed Any finite number. The generator keeps the low 32 bits of its integer part. */
  constructor(seed: number) {
    this.state = Number.isFinite(seed) ? Math.trunc(seed) >>> 0 : 0;
  }

  /** Returns a number from 0 (included) to 1 (not included). */
  public next(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** Returns a number from -1 to 1 (1 not included). */
  public nextSigned(): number {
    return this.next() * 2 - 1;
  }

  /** Returns true or false with the same chance. */
  public coin(): boolean {
    return this.next() < 0.5;
  }
}
